<nz-modal
  [(nzVisible)]="host.sectionModal.visible"
  [nzMaskClosable]="host.sectionModal.properties?.['maskClosable'] ?? true"
  [nzTitle]="sectionModalTitle"
  [nzContent]="sectionModalContent"
  [nzFooter]="showSectionFooter ? sectionModalFooter : null"
  (nzOnCancel)="host.hideSectionModalDialog()"
  [nzBodyStyle]="sectionBodyStyle"
  [nzStyle]="host.sectionModal.properties?.['nzStyle']"
  [nzWidth]="host.sectionModal.properties['width']"
  [nzClosable]="!host.sectionModal.properties?.['hideClose']"
>
  <ng-template #sectionModalTitle>{{ host.sectionModal.title }}</ng-template>
  <ng-template #sectionModalContent>
    <div class="scrollable-container">
      <app-section [section]="host.sectionModalSection"></app-section>
    </div>
  </ng-template>
  <ng-template #sectionModalFooter>
    @if (hasSectionActions) {
      @for (element of host.sectionModal.actions?.subSectionElements; track $index) {
        @if (element.visible) {
          <app-element [element]="element"></app-element>
        }
      }
    } @else {
      <button nz-button nzType="default" (click)="host.hideSectionModalDialog()">Cerrar</button>
    }
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="host.simpleModal.visible"
  [nzTitle]="simpleModalTitle"
  [nzContent]="simpleModalContent"
  [nzFooter]="simpleModalFooter"
  (nzOnCancel)="host.hideSimpleModalDialog()"
  [nzWidth]="host.simpleModal.properties['width']"
>
  <ng-template #simpleModalTitle>{{ host.simpleModal.title }}</ng-template>
  <ng-template #simpleModalContent>
    <div>
      @if (host.simpleModal.type === 'html') {
        <span [innerHtml]="host.simpleModal.content"></span>
      }
      @if (host.simpleModal.type === 'text') {
        <span>{{ host.simpleModal.content }}</span>
      }
    </div>
  </ng-template>
  <ng-template #simpleModalFooter>
    @for (option of host.simpleModal.options; track $index; let i = $index) {
      <button nz-button [nzType]="option.style" (click)="host.simpleModal.callback(i)">{{ option.name }}</button>
    }
  </ng-template>
</nz-modal>
